module.exports = __webpack_public_path__ + "img/qianbao_bg.85b10493.png";